import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, XCircle, Loader2, Clock } from "lucide-react";
import { api } from "@/lib/api";

export default function PaymentResult() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const orderId = params.get("order_id");
  const [state, setState] = useState({ loading: true, data: null, error: null });

  useEffect(() => {
    if (!orderId) {
      setState({ loading: false, data: null, error: "No order_id provided" });
      return;
    }
    api
      .post("/payments/verify", { order_id: orderId })
      .then(({ data }) => setState({ loading: false, data, error: null }))
      .catch((e) => setState({ loading: false, data: null, error: e?.response?.data?.detail || "Verification failed" }));
  }, [orderId]);

  const paid = state.data?.order_status === "PAID";
  const Icon = state.loading ? Loader2 : state.error ? XCircle : paid ? CheckCircle2 : Clock;
  const color = state.error ? "text-red-400" : paid ? "text-emerald-400" : "text-amber-400";

  return (
    <div className="co-grid flex min-h-screen items-center justify-center bg-[#08090E] p-4">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} data-testid="payment-result" className="co-scanline relative w-full max-w-md rounded-2xl border border-[#1E2433] bg-[#10131B] p-8 text-center">
        <Icon className={`mx-auto h-14 w-14 ${color} ${state.loading ? "animate-spin" : ""}`} />
        <h1 className="font-display mt-4 text-2xl font-extrabold text-slate-100">
          {state.loading ? "Verifying payment…" : state.error ? "Verification failed" : paid ? "Payment successful" : `Status: ${state.data?.order_status}`}
        </h1>
        {state.data && (
          <p className="mt-2 text-sm text-slate-400">
            {state.data.plan_name} · ₹{state.data.amount}
          </p>
        )}
        {orderId && <p className="mt-1 break-all font-mono text-[10px] text-slate-600">{orderId}</p>}
        {state.error && <p className="mt-2 text-sm text-red-400/80">{state.error}</p>}
        <button data-testid="result-home" onClick={() => navigate("/")} className="co-btn-primary mt-6 w-full rounded-lg py-2.5 text-sm">
          Back to store
        </button>
      </motion.div>
    </div>
  );
}
